// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { changePasswordActionsStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

changePasswordActionsStyles.cancelButton = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};

changePasswordActionsStyles.buttonGridContainer = {
    gap: 10,
    offsetCss: css`
        ${xScreen("lt", "sm")} {
            flex-direction: column-reverse;
            > ${GridItemStyle} {
                width: 100%;
            }
        }
    `,
};

changePasswordActionsStyles.buttonGridItem = {
    css: css`
        &&&& {
            flex-basis: fit-content;
            max-width: fit-content;
            ${xScreen("lt", "sm")} {
                max-width: 100%;
            }
        }
    `,
};
